import React from 'react';
import { convert } from 'chromatism2';
import styles from './colorpicker.less.js';
import { isLightColor } from '../../../../utils/color-utils.js';

class ColorGrid extends React.Component {
    constructor() {
        super(...arguments);
        this.handleColorClick = (color) => {
            this.props.onColorClick(color);
        };
        this.handleMouseEnter = (color) => {
            this.props.onColorEnter(color);
        };
        this.handleMouseLeave = () => {
            this.props.onColorLeave();
        };
        this.preventBlur = (e) => {
            e.preventDefault(); // 配合onMouseDown，不触发blur
        };
    }
    normalize(color) {
        var _a;
        if (!color) {
            return {
                colour: convert('#FFFFFF'),
                alpha: 1,
                disabled: true,
            };
        }
        let colour;
        let alpha = 1;
        let disabled = false;
        const rgba = /rgba?\((\s*\d+\s*,\s*\d+\s*,\s*\d+)(,\s*(\d+(\.\d+)?))?\)/.exec(color);
        try {
            if (rgba) {
                colour = convert(`rgb(${rgba[1]})`);
                alpha = parseFloat(((_a = rgba[2]) !== null && _a !== void 0 ? _a : '1').replace(',', ''));
            }
            else if (color.startsWith('#')) {
                colour = convert(color);
            }
            else {
                colour = convert('#FFFFFF');
                disabled = true;
            }
        }
        catch (_b) {
            colour = convert('#FFFFFF');
            disabled = true;
            if (this.props.onError) {
                this.props.onError();
            }
        }
        return { colour, alpha, disabled };
    }
    render() {
        const { colors } = this.props;
        if (!(colors instanceof Array)) {
            return null;
        }
        const selected = this.normalize(this.props.selected);
        return (React.createElement("div", { className: styles.grid, onMouseDown: this.preventBlur }, colors.map((array, i) => {
            const colorLine = array.map((color, j) => {
                const { colour, alpha, disabled } = this.normalize(color);
                const isLight = isLightColor(Object.assign(Object.assign({}, colour.rgb), { alpha }));
                const innerbox = React.createElement("div", { className: [styles.box, disabled ? styles.disabled : ''].join(' '), style: {
                        backgroundColor: `rgba(${colour.rgb.r}, ${colour.rgb.g}, ${colour.rgb.b}, ${alpha})`,
                        borderColor: isLight ? 'rgba(0, 0, 0, 0.08)' : 'transparent',
                    }, onClick: () => this.handleColorClick(color), onMouseEnter: () => this.handleMouseEnter(color), onMouseLeave: () => this.handleMouseLeave(), key: `color-box-${i}-${j}` });
                if (colour.hex.toUpperCase() === selected.colour.hex.toUpperCase()
                    && alpha === selected.alpha
                    && !selected.disabled) {
                    return React.createElement("div", { key: `color-box-${i}-${j}`, className: styles.selected }, innerbox);
                }
                return innerbox;
            });
            return React.createElement("div", { className: styles['box-line'], key: `color-line-${i}` }, colorLine);
        })));
    }
}

export { ColorGrid };
//# sourceMappingURL=color-grid.js.map
